import request from '../shared/request';
import * as hosts from '../shared/constants/hosts';

/**
 * https://yapi-vpc.medlinker.com/project/279/interface/api/45660
 * 获取faceId等数据，打开人脸核身参数
 */
export function getFaceId() {
  return request.post<
    { name: string; idNo: string; isPatient: boolean },
    {
      userId: number;
      faceId: string;
      orderNo: string;
      nonce: string;
      sign: string;
      optimalDomain: string;
    }
  >(`/base-interface/v1/face/getFaceId`, {
    baseURL: hosts.API,
  });
}

/**
 * https://yapi-vpc.medlinker.com/project/279/interface/api/40519
 * 查询人脸识别结果
 */
export function queryFaceResult() {
  return request.post<{ orderNo: string }, { pass: boolean }>(
    `/base-interface/v1/face/queryFace`,
    {
      baseURL: hosts.API,
    }
  );
}
